const premisesEn = {
    premise: require('lang/en/premises/Premise').default,
    zone: require('lang/en/premises/Zone').default,
    level: require('lang/en/premises/Level').default,
    unit: require('lang/en/premises/Unit').default,
    assignUnit: require('lang/en/premises/AssignUnit').default,
    vacateUnit: require('lang/en/premises/VacateUnit').default,
    gate: require('lang/en/premises/Gate').default,
    parking: require('lang/en/premises/Parking').default,
    vehicle: require('lang/en/premises/Vehicle').default,
    rules: require('lang/en/premises/Rules').default,
    vendor: require('lang/en/premises/Vendor').default,
};

export default premisesEn;